import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import image from 'images/event_types/scope_empty_state.png';
const containerCss = "c1man1mf";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const paragraphCss = "pexk2bm";
const Paragraph = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(paragraphCss, props.className)} />;
});
const descriptionCss = "d1lgbkbk";
const Description = forwardRef((props, ref) => <Paragraph ref={ref} {...props} className={classNames(descriptionCss, props.className)} />);
const EmptyState = () => <Container>
    <div>
      <img src={image} width="120" height="78" alt="" />
    </div>
    <Paragraph>
      {I18n.t('publisher.event_types.scope_dropdown.empty_search_state.title')}
    </Paragraph>
    <Description>
      {I18n.t('publisher.event_types.scope_dropdown.empty_search_state.description')}
    </Description>
  </Container>;
export default EmptyState;

require("./empty_state.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./empty_state.js");